export default function initFixAnchors() {
  const host = (() => {
    try {
      return new URL(window.NaturkartanConfig?.baseUrl || ``).host
    } catch {
      return ``
    }
  })()

  if (!host && window.NaturkartanConfig.environment == `dev`) {
    console.warn(
      `Could not initFixAnchors: unable to determine host from NaturkartanConfig.baseUrl`
    )
  }

  document.addEventListener(`click`, (e) => {
    if (
      e.defaultPrevented ||
      e.target.tagName != `A` ||
      !e.target.closest(`.fix-anchors`)
    )
      return

    e.preventDefault()

    const targetBlank = e.target.target == `_blank`
    let { href } = e.target

    if (href.startsWith(`http://`)) {
      href = href.replace(`http://`, `https://`)
    } else if (href.startsWith(`www.`)) {
      href = `https://www.${href}`
    }

    if (href.startsWith(`https://${host}`)) {
      href = href.replace(`https://${host}`, ``)
    } else if (href.startsWith(`https://www.${host}`)) {
      href = href.replace(`https://www.${host}`, ``)
    }

    if (!href) href = `/`

    if (href.startsWith(`/`)) {
      // internal
      if (targetBlank || e.ctrlKey || e.metaKey) {
        window.open(href, `_blank`, `noopener`)
      } else {
        if (window.liveSocket) window.liveSocket.js().navigate(href)
        else window.location.href = href
      }
    } else {
      // external
      window.open(href, `_blank`, `noopener`)
    }
  })
}
